import createAsyncThunkFromFetch from '../../store/middlewares/createAsyncThunkFromFetch';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { PackageSubscription } from './subscriptions.types';
import { getRoomSubscriptions, postNewRoomSubscription } from './subscriptions.api';

const name = 'subscriptions';

export const fetchRoomSubscriptions = createAsyncThunkFromFetch(`${name}/fetchRoomSubscriptions`, getRoomSubscriptions);

export const addRoomSubscription = createAsyncThunkFromFetch(`${name}/addRoomSubscription`, postNewRoomSubscription);

const subscriptionProviderAdapter = createEntityAdapter<PackageSubscription>({
  selectId: subscription => subscription.id,
});

export const subscriptionProviderSelectors = subscriptionProviderAdapter.getSelectors();

const paymentProviderSlice = createSlice({
  name,
  initialState: subscriptionProviderAdapter.getInitialState<{
    roomSubscriptions: Record<string, string[]>;
  }>({
    roomSubscriptions: {},
  }),
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchRoomSubscriptions.fulfilled, (state, { payload, meta }) => {
        const { roomId } = meta.arg;
        subscriptionProviderAdapter.upsertMany(state, payload);
        state.roomSubscriptions[roomId] = payload.map(p => p.id);
      })
      .addCase(addRoomSubscription.fulfilled, (state, { payload, meta }) => {
        const { roomId } = meta.arg;
        subscriptionProviderAdapter.upsertMany(state, payload);
        state.roomSubscriptions[roomId] = [...state.roomSubscriptions[roomId], ...payload.map(p => p.id)];
      });
  },
});

const { reducer } = paymentProviderSlice;

export default reducer;
